import type { RouteRecordRaw } from 'vue-router';

/** Advanced Costing screens (WP8.9, ADR-092). */
export const costingRoutes: RouteRecordRaw[] = [
  {
    path: 'costing/scenarios',
    name: 'costing-scenarios',
    component: () => import('../pages/costing/CostScenariosPage.vue'),
    meta: { requiresModule: 'costing' },
  },
  {
    path: 'costing/calculations',
    name: 'costing-calculations',
    component: () => import('../pages/costing/CostCalculationsPage.vue'),
    meta: { requiresModule: 'costing' },
  },
];
